const stats = [
  { label: "ACTIVE PROJECTS", value: "4", note: "+1 this week" },
  { label: "PENDING REQUESTS", value: "2", note: "Awaiting review" },
  { label: "UPCOMING BOOKINGS", value: "3", note: "Next: Tomorrow" },
  { label: "PENDING PAYMENTS", value: "₹1.2L", note: "1 invoice due" },
  { label: "IN PRODUCTION", value: "2", note: "62% avg progress" },
  { label: "COMPLETED", value: "9", note: "All time" },
];

export default function StatsGrid() {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4">
      {stats.map(({ label, value, note }) => (
        <div key={label} className="bg-white border border-gray-100 rounded-2xl p-5">
          <p className="text-[11px] font-semibold text-gray-400 tracking-wide mb-2">
            {label}
          </p>
          <p className="text-2xl font-extrabold text-gray-900">{value}</p>
          <p className="text-xs text-gray-500 mt-1">{note}</p>
        </div>
      ))}
    </div>
  );
}